import { action, computed, observable } from 'mobx';

import { SIGNUP_ALLOWED_COUNTRIES, EU_COUNTRIES_CODES } from '~/common/utils/consts.js';
import axios from 'axios';
import fatalErrorModal from '~/common/utils/fatalErrorModal.js';

class UserLocationClass {
    @observable userLocation;
    @observable UserLocationError = false;
    @observable ipAddress;

    constructor() {
        this.getIpAddress();
        this.getUserLocation();
    }

    @action getIpAddress() {
        axios.post('/util/ip')
            .then((response) => {
                return this.setIpAddress(response.data);
            }).catch((err) => {
                fatalErrorModal();
                return err;
            });
    }

    // get users location
    @action getUserLocation() {
        // if we don't already have the users location
        if (!this.userLocation) {
            // get users location from API
            axios.post('/util/geoip')
                .then((response) => {
                    // set user location with response data
                    this.setUserLocationError(false);
                    return this.setUserLocation(response.data);
                }).catch((err) => {
                    this.setUserLocation(false);
                    // catch errors from sources other than API
                    this.setUserLocationError(true);
                    return err;
                });
        }
    }

    @action setIpAddress(str) {
        if (typeof str === 'string') {
            this.ipAddress = str;
        }
    }

    // set user location error
    @action setUserLocationError(bool) {
        // if bool exists and is a boolean
        if (typeof bool === 'boolean') {
            this.UserLocationError = bool;
        }
    }

    // set user location
    @action setUserLocation(data) {
        // if data exists and is object or array
        if (typeof data === 'object' || typeof data === 'boolean') {
            this.userLocation = data;
        }
    }

    @computed get UserCountryCode() {
        return (this.userLocation && this.userLocation.countrycode) ?
            this.userLocation.countrycode.toUpperCase()
            :
            'US';
    }

    @computed get localAreaCode() {
        return this.userLocation && this.userLocation.areacode;
    }

    @computed get isUserInUS() {
        return this.userLocation && this.userLocation.countrycode.toUpperCase() === 'US';
    }

    @computed get isUserInNorthAmerica() {
        return this.userLocation && (this.userLocation.countrycode.toUpperCase() === 'US' || this.userLocation.countrycode.toUpperCase() === 'CA');
    }

    @computed get isSignupAllowed() {
        // allow signups if API has not resolved
        if (!this.userLocation || !this.userLocation.countrycode) return true;
        return this.userLocation && SIGNUP_ALLOWED_COUNTRIES.find((country) => {
            return country === this.userLocation.countrycode.toUpperCase();
        });
    }

    @computed get isUserInEu() {
        return this.userLocation && EU_COUNTRIES_CODES.includes(this.userLocation.countrycode.toUpperCase());
    }
}

const userLocationStore = new UserLocationClass();
export { userLocationStore, UserLocationClass };
